import * as React from 'react'
import { classnames } from '@halo/_utils/classnames'
import { observer } from 'mobx-react'
import WhiteLabelsList from '@halo/components/white-labels-list/white-labels-list'

@observer
export class WhiteLabels extends React.Component<any, any> {
    public render() {
        return (
            <div className={classnames('page', 'white-labels')}>
                <div className={classnames('page-wrapper')}>
                    <WhiteLabelsList />
                </div>
            </div>
        )
    }
}
